export const formatEmailRegex = (emails: string[]) => {
  const formattedEmails = emails.map((email) => {
    if (email !== '.*') {
      return email.replace('.', '\\.');
    }
    return email;
  });

  const formattedEmailString = formattedEmails.join('|');

  return formattedEmailString;
};